import React, { FC, useMemo } from 'react';
import { Divider, List, Pagination, Space } from 'antd';
import { SearchResultCard } from './SearchResultCard';
import { useSearchContext } from '../SearchContext';
import stylesModule from './SearchComponents.module.less';
import Utils from '../../../utils/Utils';
import { TextBlock } from '../../../uicomp/atmos/content-block/ContentBlock';
import { useCachedData } from '../../../connection/CacheContext';

const styles: any = stylesModule;

type Props = {
  showPagination: boolean;
};

export const SearchResultList: FC<Props> = (props) => {
  const { enumValue } = useCachedData();
  const ctx = useSearchContext();
  const locationText = useMemo(() => {
    const a = ctx.query.location;
    const c = ctx.query.country;
    if (!a && !c) {
      return 'Everywhere';
    }

    const arr = [
      ...(a ?? []).map((item) => Utils.capitalizeFirstLetter(enumValue['Location']?.[item])),
      ...(c ?? []).map((item) => Utils.capitalizeFirstLetter(enumValue['Country']?.[item])),
    ];
    if (arr.length === 1) {
      return arr[0];
    }
    if (arr.length < 5) {
      return [arr.slice(0, -1).join(', '), arr.slice(-1)[0]].join(' and ');
    }
    return [arr.slice(0, 2).join(', '), `${arr.length - 2} more locations`].join(' and ');
  }, [ctx.query.country, ctx.query.location, enumValue]);
  // const arr = locationText.split(' ');
  // for (let i = 0; i < arr.length; i++) {
  //   arr[i] = arr[i].charAt(0).toUpperCase() + arr[i].slice(1);
  // }
  // const locationText2 = arr.join(' ');
  return (
    <Space direction="vertical" style={{ width: '100%' }}>
      {(ctx.results?.total ?? 0) > 0 && (
        <TextBlock className={styles.jobCountInfo} secondary>
          {[`${ctx.results?.total ?? 0}`, ctx.query.search, ctx.type, 'in', locationText]
            .filter((s) => !!s)
            //.map((value) => (value ? enumValue['Location'][value] : value))
            .join(' ')}
        </TextBlock>
      )}
      <List>
        {ctx.results?.jobPost.map((result) => (
          <List.Item
            onClick={() => ctx.setSelected(result)}
            className={Utils.mergeClasses({
              [styles.SearchResultListItem]: true,
              [styles.SearchResultListItemSelected]: ctx.selected?.jobPostId === result.jobPostId,
            })}
            key={result.jobPostId}>
            <SearchResultCard value={result} />
          </List.Item>
        ))}
      </List>
      {props.showPagination && (
        <>
          <Divider />
          <Pagination
            current={(ctx.query?.from ?? 0) / 10 + 1}
            className={styles.pagination}
            showSizeChanger={false}
            responsive
            total={ctx.results?.total ?? 0}
            onChange={(page) => ctx.search({ from: (page - 1) * 10 })}
          />
        </>
      )}
    </Space>
  );
};
